module.exports = __webpack_public_path__ + "static/media/kargil-equipments.4979a735.png";